import styled from '@emotion/styled';

export const NodeContainer = styled.div`
  margin-left: 16px;
`;

export const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const NodeContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const Checkbox = styled.input`
  margin-right: 8px;
  width: 16px;
  height: 16px;
`;

export const NodeName = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
`;

export const ToggleButton = styled.button`
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: #e5e7eb;
  }
`;

export const ChildrenContainer = styled.div`
  margin-left: 16px;
`;